const GoogleIcon = ({ size = 24 }) => {
  return (
    <img
      src={require("../../../assets/images/google.svg").default}
      alt="google"
      width={size}
    />
  );
};

export default GoogleIcon;
